module.exports = __webpack_public_path__ + "img/四川天府新区新星幼儿园.270e182f.jpg";